$(document).ready(function () {
    var group;

    $('#add-new-eportfolio-group-btn, .edit-eportfolio-group').on('click', function () {
        group = undefined;
    });

    $('#addediteportfoliogroup').on('show.bs.modal', function (e) {
        addEditGroupValidation.resetForm();
        $('#submission-warning').hide();
        $('.move-group-member-btn').show();

        if ($(e.relatedTarget).data('group') !== undefined) {
            group = $(e.relatedTarget).data('group');
        }

        var modal = $(this);
        var members_select_box = $(modal).find('select[name="users[]"]');
        var modal_title = $(modal).find('span.title');
        var group_title_box = $(modal).find('input[type="text"][name="name"]');
        var acyr = $(modal).find('input[type="hidden"][name="acyr"]');
        var degreeprogyr = $(modal).find('input[type="hidden"][name="degreeprogyr"]');
        var group_id = $(modal).find('input[type="hidden"][name="id"]');

        if (group === undefined) {
            $(modal_title).text('Create Group');
            $(members_select_box).empty();
            $(group_title_box).val('');
            $(group_title_box).unbind('keyup');
            $(group_id).val('');
            $(acyr).val($('ul.acyr-filter li.active').text().trim());
            $(degreeprogyr).val($('ul.degreeprogyr-filter li.active').text().trim());
            $('.move-group-member-btn').hide();
        } else {
            $(modal_title).text('Edit Group: ' + group.name);
            $(group_title_box).val(group.name);
            $(group_title_box).on('keyup', function () {
                $(modal_title).text('Edit Group: ' + $(group_title_box).val());
            });

            $(group_id).val(group.id);
            $(acyr).val(group.acyr);
            $(degreeprogyr).val(group.degreeprogyr);
            $(members_select_box).empty();
            if (group.users.length > 0) {
                $.each(group.users, function (idx, user) {
                    var type = '';
                    var submitted = '';
                    var fullname = '';
                    if (user.basicrole === 'basic') {
                        type = 'Student';
                    } else {
                        type = 'Staff';
                    }
                    if (user.submission_id !== null) {
                        $('#submission-warning').show();
                        submitted = ' - Submitted';
                    }
                    fullname = user.firstname + ' ' + user.lastname + ' (' + type + ')';
                    $(members_select_box).append('<option selected value="' + user.id + '" title="' + fullname + submitted + '">' + fullname + '</option>');
                });
            } else {
                $('.move-group-member-btn').hide();
            }
            $(members_select_box).trigger('change');
            $(members_select_box).on('select2:unselecting', function (e) {
                // eslint-disable-next-line @stylistic/max-statements-per-line
                var unselectedUser = group.users.find((object) => { return object['id'] === e.params.args.data.id });

                // Disable selection if student has a submission
                if (unselectedUser !== undefined && unselectedUser.submission_id !== null) {
                    e.preventDefault();
                }
            });
        }

        function formatUser(user) {
            return user.name + ' (' + (user.basicrole === 'basic' ? 'Student' : 'Staff') + ')';
        }

        function fetchUser(term, programmeYear) {
            return $.ajax({
                url: base_url + 'eportfolio/ajax_users',
                dataType: 'json',
                type: 'GET',
                data: {
                    programmeYear: programmeYear,
                    term: term,
                },
            });
        }

        function addUserToSelect(select, user) {
            const optionExists = select.find('option[value="' + user.id + '"]').length > 0;
            if (optionExists === false) {
                const option = new Option(formatUser(user), user.id, true, true);
                select.append(option).trigger('change');
            }
        }

        $(members_select_box).select2({
            width: '100%',
            theme: 'bootstrap',
            minimumInputLength: 3,
            ajax: {
                url: base_url + 'eportfolio/ajax_users',
                dataType: 'json',
                delay: 250,
                type: 'GET',
                data: function (params) {
                    return {
                        term: params.term,
                    };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, user => ({ id: user.id, text: formatUser(user) })),
                    };
                },
            },
            templateSelection: item => item.text,
        });

        // Handle pasting a list of emails
        $(members_select_box).off('select2:open.multiplePaste')
            .on('select2:open.multiplePaste', function () {
                const searchInput = $('.select2-container--open .select2-search__field');

                searchInput.off('paste.multiplePaste').on('paste.multiplePaste', function (e) {
                    const clipboardData = e.originalEvent.clipboardData || window.clipboardData;
                    const pastedText = (clipboardData.getData('text') || '')
                        .replaceAll(/[\r\n]+/g, ' ')
                        .trim();

                    const terms = pastedText
                        .split(/[\s,]+/)
                        .map(term => term.trim().toLowerCase())
                        .filter(term => term.length);

                    function isValidEmail(email) {
                        return $.validator.methods.email.call({ optional: () => false }, email, null);
                    }

                    if (terms.every(isValidEmail) === false) {
                        return;
                    }

                    e.preventDefault();

                    const select        = $(members_select_box);
                    const programmeYear = $(degreeprogyr).val();

                    for (const term of terms) {
                        fetchUser(term, programmeYear).done((data) => {
                            if (data && data.length > 0) {
                                addUserToSelect(select, data[0]);
                            }
                        });
                    }
                });
            });

        addDisabledStyling();

        $(members_select_box).on('change', function () {
            // A timeout is needed in order to force this to run after select2 has rendered
            setTimeout(function () {
                addDisabledStyling();
            });
        });
    });

    // Apply disabled styling to any students with a submission
    function addDisabledStyling() {
        var elements = document.querySelectorAll('li[title~="Submitted"]');
        for (const elem of elements) {
            var html = $(elem).html().replace(' - Submitted', '');
            $(elem).html(html).css({ 'background-color': '#d5d5d5' });
            $(elem).children().hide();
        }
    }

    $('#movegroupmembers').on('show.bs.modal', function () {
        moveGroupValidation.resetForm();
        var modal = $(this);
        var members_select_box = $(modal).find('select[name="users[]"]');
        var groups_select_box = $(modal).find('select[name="movetogroupid"]');
        var modal_title = $(modal).find('span.title');
        var acyr = $(modal).find('input[type="hidden"][name="acyr"]');
        var degreeprogyr = $(modal).find('input[type="hidden"][name="degreeprogyr"]');
        var group_id = $(modal).find('input[type="hidden"][name="currentgroupid"]');

        $(modal_title).text('Move Group Members from: ' + group.name);
        $(group_id).val(group.id);
        $(acyr).val(group.acyr);
        $(degreeprogyr).val(group.degreeprogyr);
        $(members_select_box).empty();
        $.each(group.users, function (idx, user) {
            var type = '';
            if (user.basicrole === 'basic') {
                type = 'Student';
            } else {
                type = 'Staff';
            }
            $(members_select_box).append(new Option(user.firstname + ' ' + user.lastname + ' (' + type + ')', user.id));
            if (user.submission_id !== null) {
                $('#submission-warning').show();
            }
        });
        $(members_select_box).trigger('change');

        $(groups_select_box).empty().append('<option disabled selected>Select a group</option>');
        $.each(allgroups, function (idx, groupOption) {
            if (groupOption.id !== group.id) {
                $(groups_select_box).append(new Option(groupOption.name, groupOption.id));
            }
        });
        $(groups_select_box).trigger('change');

        $(members_select_box).select2({
            width: '100%',
            theme: 'bootstrap',
            placeholder: 'Select group members',
            templateSelection: function (item) {
                return item.text;
            },
        });
    });

    // Validate forms
    var addEditGroup = $('#add-edit-eportfolio-group-form');
    var addEditGroupValidation = $(addEditGroup).validate({
        errorPlacement: function (error, element) {
            if (element.hasClass('select2') && element.next('.select2-container').length) {
                error.insertAfter(element.next('.select2-container'));
            } else {
                error.insertAfter(element);
            }
        },
        onkeyup: false,
        onclick: false,
        rules: {
            name: {
                required: true,
            },
        },
        messages: {
            name: 'Please enter a name for the ePortfolio group',
        },
    });

    var moveGroup = $('#move-eportfolio-group-members-form');
    var moveGroupValidation = $(moveGroup).validate({
        errorPlacement: function (error, element) {
            if (element.hasClass('select2') && element.next('.select2-container').length) {
                error.insertAfter(element.next('.select2-container'));
            } else {
                error.insertAfter(element);
            }
        },
        onkeyup: false,
        onclick: false,
        rules: {
            'users[]': {
                required: true,
            },
            movetogroupid: {
                required: true,
            },
        },
        messages: {
            'users[]': 'Please select one or more group members to move',
            movetogroupid: 'Please select a group to move to',
        },
    });

    // Disable submit button after first click to avoid duplicate form submissions
    $(addEditGroup, moveGroup).submit(function (e) {
        if ($(e.target).valid()) {
            $('.submit-btn').prop('disabled', true);
            $('.submit-btn').html('<i class="fa-regular fa-save"></i> Saving...');
        }
    });

    $('#copyeportfoliogroups').on('show.bs.modal', function (e) {
        var modal               = $(this);
        var modal_title         = $(modal).find('span.title');
        var timetablegroups     = $('#timetablegroups');
        var eportfolioyeargroup = $('#eportfolioyeargroup');
        var btnselectgroups     = $('.btn-selectgroups');
        var acyr                = $('ul.acyr-filter li.active').text().trim();

        $(modal_title).text('Copy Groups from Timetable');

        eportfolioyeargroup.on('change', function () {
            var degprgyr    = $(this).find(':selected').val();
            var groupname   = $(this).find(':selected').text();
            var ajaxloading = $('.ajaxloading');
            $.ajax({
                type: 'GET',
                url: base_url + 'eportfolio/ajax_groups',
                data: { degreeprogrammeyear: degprgyr, acyr: acyr },
                dataType: 'json',
                beforeSend: function () {
                    $(ajaxloading).html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + ' fa-fw"></i> Loading Groups....');
                },
                success: function (groups) {
                    ajaxloading.empty();
                    btnselectgroups.show();

                    var groups_html = $.map(groups, function (group) {
                        if (group.iswardteaching == 0) {
                            return '<li><input type="checkbox" id="' + group.id + '" name="groups[]" title="' + group.name + ' (' + group.acyr + ')" value="' + group.id + '" /> <label role="button" for="' + group.id + '">' + group.name + ' (' + group.acyr + ') (' + group.user_count + ' students)</label></li>';
                        }
                    }).join('');

                    timetablegroups.empty()
                        .append(groups_html);
                },
            });
        });
        btnselectgroups.click(function () {
            $(this).prop('disabled', true)
                .html('<i class="' + FontAwesome.prefix('solid', 'spinner', true) + ' fa-fw"></i> Building Groups....')
                .parents('form').submit();
        });
    });

    $('#deleteeportfoliogroup').on('show.bs.modal', function (e) {
        var group = $(e.relatedTarget).data('group');
        var modal = $(this);

        $(modal).find('span.group-name').html(group.name);
        $(modal).find('a.delete-button').prop('href', base_url + 'eportfolio/deletegroup/' + group.id);
    });
});
